export default {
    "AppTitle":"Registro.it - Statistiche",
    "wrongRequestPathTitle":"Percorso Richiesta Errato",
    "wrongRequestPath":" è una richiesta sbagliata.",
    "SUCCEEDED": "SUCCESSO",
    "FAILED": "FALLITO",
    "WARNING": "ATTENZIONE",
    "date":"Data",
    "year": "Anno",
    "italian":"Italiano",
    "english":"Inglese",
    "emptyChart":"Nessun Dato Disponibile",
    "options":"Opzioni",
    "noDrilldown": "non disponibile",
    "filters":"Filtri",
    "helpGuide":"Attiva/disattiva una guida sui vari elementi della pagina",

    "crescitaMensile": "Crescita Mensile",
    "crescitaInizioAnno": "Crescita Inizio Anno",
    "crescitaMensileEdu": "Crescita Mensile di EDU.IT",
    "crescitaInizioAnnoEdu":"Crescita Inizio Anno di EDU.IT",
    "crescitaPrimoAnnoEdu":"Crescita Primo Anno di EDU.IT",
    "crescitaAnno":"Crescita anno",
    "loadingChart": "Caricamento Grafico in Corso",
    // Charts
    "chart.registeredDomainName":"Numero Domini Registrati",
    "chart.registeredDomainNameEDU":"Numero Domini Registrati EDU.IT",
    "chart.yearGrowthRate":"Tasso Crescita Annuale",

    // Guide
    "dataTable.guide":"**Tabella Dati**\n\nRappresentazione in tabella dei dati che compongono il grafico. E' possibile esportare i dati in formato *CSV* dal menu *Esporta*",
    "filters.guide":"**Filtri**\n\nPer alcuni grafici è possibile applicare dei filtri che modificano i valori che vengono riportati sul grafico. I filtri possono essere di varia natura a seconda del tipo di grafico, come ad esempio restrizioni di tipo geografico (paesi, aree, regioni) o sulla tipologia del Registrante (italiani/stranieri) ecc..\nUtilizzando il link *Ripristina filtri* è possibile tornare ai valori iniziali non filtrati.",
    "domainTab.guide":"**Statistiche disponibili sui nomi a dominio**\n\nI dati visualizzabili relativi ai nomi a dominio sono di due tipi:\n * **Crescita**: per visualizzare i dati relativi alla crescita nel tempo del numero dei nomi a dominio .it.\n * **Operazioni**: statistiche sulle principali operazioni sui nomi a dominio (registrazioni, cancellazioni, rinnovi, cambi registrar, ecc.).",
    "registrantTab.guide":"**Statistiche disponibili su dati relativi ai Registranti**\n\nLe statistiche visualizzabili per i Registranti sono relative alle operazioni più comuni sui nomi a dominio (registrazioni, cancellazioni, rinnovi ecc..), ma mostrate dal punto di vista della localizzazione geografica o tipologia del Registrante (italiani/stranieri).",
    "toolbar.export.guide":"**Esportazione Dati Grafico**\n\nL'esporazione può avvenire nei seguenti modi:\n\n1. **Come Immagine (PNG)**: permette di esportare in formato PNG l'immagine del grafico visualizzato, scegliendo tra tre dimensioni disponibili.\n\n2. **Formato testuale CSV**: esporta i dati in formato testo *CSV* solo se disponibile la visualizzazione in tabella dei dati del grafico.",
    "mainmenu.guide":"**MENU PRINCIPALE**\n\nIl menu principale permette di selezionare il tipo di dato che ci interessa. Sono previste tre opzioni:\n * **Domini**: statistiche relative alle operazioni sui nomi a dominio.\n * **Registrar**: statische sui Registrar o sulle operazioni sui nomi a dominio basandosi sulla localizzazione geografia del Registrar.\n* **Registranti**: statische sulle operazioni sui nomi a dominio in base alla localizzazione geografica e tipologia del Registrante (italiani/stranieri).",
    "registrarTab.guide":"**Statistiche disponibili su dati relativi ai Registrar**\n\nI dati mostrati sono dal punto di vista della localizzazione geografica dei Registrar e sono di 3 tipi:\n * **Registrar**: per vedere i dati relativi al numero di Registrar attivi.\n * **Crescita**: per visualizzare il numero e la percentuale di nomi a dominio mantenuti dai Registrar.\n * **Operazioni**: per le statistiche sulle operazioni più comuni sui nomi a dominio effettuate dai Registrar.",
    "generic.chart.guide":"**Grafico**\n\n La rappresentazione grafica dei dati che si è scelta può variare a seconda delle selezioni dell'utente e possono essere visualizzati grafici a linea, istogrammi, ecc..\n\nIn tutti i grafici l'ascissa rappresenta il tempo, mentre l'ordinata rappresenta i valori che l'operazione selezionata assume nel tempo.\n\nSpesso gli elementi del grafico (solitamente negli istogrammi) risultano *cliccabili* permettendo di effettuare un *drilldown* temporale che permette di passare ad esempio dalla visualizzazione annuale a mensilie, giornaliera, fino ad arrivare, in alcuni casi, ad un dettaglio orario.",
    "toolbar.drilldown.guide": "**Drilldown**\n\nSe il grafico è *navigabile temporalmente* questo campo è il livello di dettaglio temporale (anno, mese, giorno) raggiunto.\n\nAttraverso i valori del *drildown* è possibile spostarsi temporalmente tornando indietro rispetto alle selezioni fatte cliccando sugli elementi del grafico.\n\nNon tutti i grafici possono essere *navigati temporalmente* e in questo caso come valore del *drilldown* comparirà **non disponibile**.",
    "toolbar.dataicon.guide":"**Tabella/Grafico**\n\n Permette di visualizzare alternativamente i dati in forma tabellare o in forma grafica.\n\nSe i dati tabellari associati non sono presenti l'icona non è attiva.",
    "languageSwitcher.guide":"**Selettore Lingua**\n\nPermette di selezionare la lingua (italiano o inglese) utilizzata nel portale delle statistiche",

    // Box title
    "domain.charts":"Grafici sui Domini",
    "registrar.charts":"Grafici sui Registrar",
    "registrant.charts": "Grafici sui Registranti",
    //
    "show.button.table": "Mostra Tabella Dati",
    "hide.button.table": "Nascondi Tabella Dati",

    // Export
    "image.small":"Dim Piccola",
    "image.medium":"Dim Media",
    "image.large":"Dim Grande",

    // header
    "domains":"Domini",
    "registrars":"Registrars",
    "registrants":"Registranti",
    "home": "home",
    "url_home": "/",
    "faq": "faq",
    "stats": "stats",
    "search": "cerca",
    "url_faq": "faq",
    "url_search": "search",

    // Filtri
    "clearFilters":"Ripristina Filtri",

    // footer
    "footer.aboutUs": "Chi siamo",
    "footer.registering": "Registra il tuo .IT",
    "footer.registrars": "I registrar",
    "footer.press": "Sala Stampa",
    "footer.registryProjects": "Progetti Registro",
    "footer.docs": "Form & Docs",
    "footer.url_aboutUs": "chi-siamo",
    "footer.url_registering": "registra-tuo-it",
    "footer.url_registrars": "registrar",
    "footer.url_press": "sala-stampa",
    "footer.url_registryProjects": "progetti-del-registro-it",
    "footer.url_docs": "docs",

    "NOIDN":"Sincrono",
    "ASYNC":"Asincrono",
    "IDN":"Domini .it IDN",
    "DOMAINS.IDN": "Domini .it IDN",
    "Sincrono": "Sincrono",
    "Asincrono": "Asincrono",
    "DOMAINS": "Domini .it",
    "Domini .it": "Domini .it",
    "Domini .it IDN": "Domini .it IDN",
    "EDU.IT": "Domini edu.it",
    "Domini edu.it": "Domini edu.it",
    "EDU.IDN.IT": "Domini edu.it IDN",
    "Domini edu.it IDN": "Domini edu.it IDN",

    "italy": "Italiani",
    "foreign": "Stranieri",

    "africa":"Africa",
    "americas":"Americhe",
    "antartica": "Antartico",
    "asia":"Asia",
    "eu-west":"Europa Occidentale",
    "eu-south":"Europa Meridionale",
    "eu-north":"Europa Settentrionale",
    "eu-east":"Europa Orientale",
    "oceania":"Oceania",
    "world": "Altro",

    // Menu Tabs
    "tabs.registrants": "Registranti",
    "tabs.domains": "Domini",
    "tabs.registrars": "Registrar",

    // Registrars
    "tab.registrar.count": "Registrar",
    "tab.registrar.registration": "Registrazioni",
    "tab.registrar.domain":"Mantenimenti",
    "tab.registrar.delete": "Cancellazioni",
    "tab.registrar.growth": "Crescita",
    "tab.registrar.transfer": "Trasferimenti",
    "subtab.registrar.transfer_in":"Trasferimenti in Ingresso",
    "subtab.registrar.transfer_out":"Trasferimenti in Uscita",
    "tab.registrar.contract_transfer":"Cessioni di Contratto",
    "subtab.registrar.contract_transfer_in":"Cessioni in Ingresso",
    "subtab.registrar.contract_transfer_out":"Cessioni in Uscita",


    // registrants
    "tab.registrant.registration":"Registrazioni",
    "tab.registrant.delete":"Cancellazioni",
    "tab.registrant.transfer":"Cambi Registrar",
    "tab.registrant.restore":"Recuperi",
    "tab.registrant.renewal":"Rinnovi",
    "subtab.registrant.transfer":"Trasferimenti",
    "subtab.registrant.transferWithTrade":"Trasferimenti con modifica del Registrante",
    "subtab.registrant.transferTotal":"Totale Trasferimenti",



    // --> Domains

    "tab.domain.registration": "Registrazioni",
    "tab.domain.delete": "Cancellazioni  ",
    "tab.domain.transfer": "Cambi Registrar",
    "tab.domain.trade": "Cambio Registrante",
    "tab.domain.renewal": "Rinnovi",
    "tab.domain.restore": "Recuperi",
    "tab.domain.reassign":"Riassegnazioni",
    "tab.domain.growth": "Crescita",


    // Titoli dei Grafici
    // REGISTRAR
    "registrar.registration.title": "Grafico Domini Registrati",
    "registrar.registration.yLabel":"Domini Registrati",
    "registrar.registration.description": "Il grafico mostra il numero delle registrazioni dei nomi a dominio in base alla tipologia dei Registrar (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese.",

    "registrar.count.title": "Grafico Registrar Attivi",
    "registrar.count.description": "Il grafico mostra il numero di Registrar attivi nel .it. I Registrar sono suddivisi tra italiani e stranieri e, un apposito filtro, consente di visualizzarne la concentrazione a livello geografico.",
    "registrar.count.yLabel":"Numero Registrar",

    "registrar.domain.title": "Grafico Domini Mantenuti",
    "registrar.domain.description": "Il grafico mostra l’andamento mensile del numero dei nomi a dominio mantenuti dai Registrar in base alla tipologia (italiani/stranieri) e alla loro localizzazione geografica.",
    "registrar.domain.yLabel":"Domini Mantenuti",

    "registrar.delete.title": "Grafico Domini Cancellati",
    "registrar.delete.description": "Il grafico mostra il numero delle cancellazioni dei nomi a dominio in base alla tipologia dei Registrar (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese.",
    "registrar.delete.yLabel":"Domini Cancellati",

    "registrar.transfer_in.title":"Grafico Trasferimenti in Ingresso",
    "registrar.transfer_in.description":"Il grafico mostra il numero dei nomi a dominio trasferiti e verso quali Registrar (italiani/stranieri e loro localizzazione geografica) sono stati trasferiti.",
    "registrar.transfer_in.yLabel":"Domini Trasferiti (Ingresso)",

    "registrar.transfer_out.title":"Grafico Trasferimenti in Uscita",
    "registrar.transfer_out.description":"Il grafico mostra il numero dei nomi a dominio trasferiti e i Registrar (italiani/stranieri e loro localizzazione geografica) che li hanno ceduti.",
    "registrar.transfer_out.yLabel":"Domini Trasferiti (Uscita)",

    "registrar.contract_transfer_in.title":"Grafico Cessioni in Ingresso",
    "registrar.contract_transfer_in.description":"Il grafico mostra il numero dei nomi a dominio trasferiti a seguito di cessione di contratto e verso quali Registrar (italiani/stranieri e loro localizzazione geografica) sono stati trasferiti.",
    "registrar.contract_transfer_in.yLabel":"Domini Ceduti (Ingresso)",

    "registrar.contract_transfer_out.title":"Grafico Cessioni in Uscita",
    "registrar.contract_transfer_out.description":"Il grafico mostra il numero dei nomi a dominio trasferiti a seguito di cessione di contratto e i Registrar (italiani/stranieri e loro localizzazione geografica) che li hanno ceduti.",
    "registrar.contract_transfer_out.yLabel":"Domaini Ceduti (Uscita)",

    "registrar.growth.title": "Grafico della Crescita dei Registrar",
    "registrar.growth.description":"Il grafico mostra la crescita dei Registrar. Grazie ad appositi filtri, è possibile visualizzare la crescita complessiva negli anni, in uno specifico anno, per tipologia (italiani/stranieri) e per area geografica.",
    "registrar.growth.yLabel":"Percentuale Crescita",

    // REGISTRANT
    "registrant.registration.title":"Grafico Domini Registrati",
    "registrant.registration.yLabel":"Domini Registrati",
    "registrant.registration.description": "Il grafico mostra il numero delle registrazioni dei nomi a dominio in base alla tipologia dei Registranti (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese, giorno e ora.",


    "registrant.delete.title":"Grafico Domini Cancellati",
    "registrant.delete.description": "l grafico mostra il numero delle cancellazioni dei nomi a dominio in base alla tipologia dei Registranti (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese, giorno e ora.",
    "registrant.delete.yLabel":"Domini Cancellati",

    "registrant.transferTotal.title":"Grafico Totale Trasferimenti Domini",
    "registrant.transferTotal.description": "Il grafico mostra il numero totale dei nomi a dominio trasferiti da un Registrar ad un altro, in base alla tipologia dei Registranti (italiani/stranieri) e alla loro localizzazione geografica. Include le operazioni di trasferimento e i trasferimenti con la modifica del Registrante. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese, giorno e ora.",
    "registrant.transferTotal.yLabel":"Domini Trasferiti (Tutti)",

    "registrant.transfer.title":"Grafico Trasferimenti Domini",
    "registrant.transfer.yLabel":"Domini Trasferiti",
    "registrant.transfer.description": "Il grafico mostra il numero dei nomi a dominio trasferiti da un Registrar ad un altro, in base alla tipologia dei Registranti (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese, giorno e ora.",

    "registrant.transferWithTrade.title":"Grafico Domini Trasferiti con Modifica del Registrante",
    "registrant.transferWithTrade.description": "Il grafico mostra il numero dei nomi a dominio, trasferiti da un Registrar ad un altro con contestuale modifica del Registrante, in base alla tipologia dei Registranti (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese, giorno e ora.",
    "registrant.transferWithTrade.yLabel":"Domini Trasferiti con Mod. Registrante",

    "registrant.restore.title":"Grafico Domini Recuperati",
    "registrant.restore.description": "Il grafico mostra il numero dei nomi a dominio recuperati a seguito di una cancellazione, in base alla tipologia dei Registranti (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese, giorno e ora.",
    "registrant.restore.yLabel":"Domini Recuperati",

    "registrant.renewal.title":"Grafico Domini Rinnovati",
    "registrant.renewal.yLabel":"Domini Rinnovati",
    "registrant.renewal.description": "Il grafico mostra il numero dei nomi a dominio rinnovati annualmente, in base alla tipologia dei Registranti (italiani/stranieri) e alla loro localizzazione geografica. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese, giorno e ora.",

    // -->Domains-->Tranfers
    "subtab.domain.transfer":"Trasferimenti",
    "subtab.domain.transferWithTrade":"Trasferimenti con modifica del Registrante",
    "subtab.domain.transferBulk":"Trasferimenti Bulk",
    "subtab.domain.transferTotal":"Totale Trasferimenti",

    // -->Registrants
    "tabs.registrants.registrations":"Registrazioni",
    "tabs.registrants.cancellations": "Cancellazioni",
    "tabs.registrants.transfers":"Trasferimenti",
    "tabs.registrants.renewals":"Rinnovi",
    "tabs.registrants.restores":"Recuperi",
    "tabs.registrants.growth":"Crescita",


    // -->Registrars
    "tabs.registrars.registrar":"Registrar",
    "tabs.registrars.registrations":"Registrazioni",
    "tabs.registrars.cancellations":"Cancellazioni",
    "tabs.registrars.maintained":"Maintenuti",

    "tabs.registrars.transfers":"Tranferimenti",

    "tabs.registrars.contractTransfers":"Cessioni di Contratti",
    "tabs.registrars.growth":"Crescita",


    // --> Registrars->transfers
    "tabs.registrars.transfers.registarOut": "Trasferimento in Uscita",
    "tabs.registrars.transfers.registarIn": "Trasferimento in Ingresso",

    // --> Registrats->contractTransfers
    "tabs.registrars.contractTransfers.transferOut": "Cessione in Uscita",
    "tabs.registrars.contractTransfers.transferIn": "Cessione in Ingresso",


    // Field
    "zone":"Zona",
    "area":"Area",
    "years": "Anno",
    "tipology":"Tipologia",
    "region": "Regione",
    "registrantType": "Tipologia Registrante",

    //
    "edu.all": '- Tutti i domini -',
    "edu.no": "Domini .it",
    "edu.only": "Domini edu.it",

    // Area italiana
    "area.all": "- Tutte le Aree -",
    "area.italy.all": "- Tutte le Aree -",
    "area.foreign.all": "- Tutte le Aree -",
    "area.nord":"Nord",
    "area.centro":"Centro",
    "area.sud":"Sud",
    "area.north":"Nord",
    "area.center":"Centro",
    "area.south":"Sud",

    "centro": "Centro",
    "nord": "Nord",
    "sud": "Sud",
    // Area Stranieri
    "area.africa": "Africa",
    "area.antartica": "Antartica",
    "area.americas": "Americhe",
    "area.asia":  "Asia",
    "area.oceania": "Oceania",
    "area.eu-east":"Europa Orientale",
    "area.eu-north": "Europa Settentrionale",
    "area.eu-west": "Europa Occidentale",
    "area.eu-south": "Europa Meridionale",


    "registrant.0": "-- Tutti i Registranti --",
    "registrant.1": "Persone Fisiche",
    "registrant.2": "Società/Ditte",
    "registrant.3": "Liberi Professionisti/Ordini Professionali",
    "registrant.4": "Enti No-Profit",
    "registrant.5": "Enti Pubblici",
    "registrant.6": "Altri Soggetti",
    "registrant.7": "Soggetti Stranieri",



    // Regioni Italia

    "region.all":"-- Tutte le Regioni --",

    // Nord

    "Emilia-Romagna":"Emilia Romagna",
    "Friuli-Venezia Giulia":"Friuli Venezia Giulia",
    "Liguria":"Liguria",
    "Lombardia":"Lombardia",
    "Piemonte":"Piemonte",
    "Trentino-Alto Adige":"Trentino Alto Adige",
    "Valle d'Aosta":"Valle d'Aosta",
    "Veneto":"Veneto",

    // Centro
    "Lazio": "Lazio",
    "Marche": "Marche",
    "Toscana": "Toscana",
    "Umbria": "Umbria",

    // Sud
    "Abruzzo":"Abruzzo",
    "Basilicata":"Basilicata",
    "Calabria":"Calabria",
    "Campania":"Campania",
    "Molise":"Molise",
    "Puglia":"Puglia",
    "Sardegna":"Sardegna",
    "Sicilia":"Sicilia",


    //// Province
    // Piemonte
    "Alessandria":"Alessandria",
    "Asti":"Asti",
    "Biella":"Biella",
    "Cuneo":"Cuneo",
    "Novara":"Novara",
    "Torino":"Torino",
    "Verbano-Cusio-Ossola":"Verbano Cusio Ossola",
    "Vercelli":"Vercelli",

    //Emilia Romagna
    "Bologna":"Bologna",
    "Ferrara":"Ferrara",
    "Forlì-Cesena":"Forlì Cesena",
    "Modena":"Modena",
    "Parma":"Parma",
    "Piacenza":"Piacenza",
    "Ravenna":"Ravenna",
    "Reggio Emilia":"Reggio Emilia",
    "Rimini":"Rimini",

    // Friuli-Venezia Giulia
    "Gorizia":"Gorizia",
    "Pordenone":"Pordenone",
    "Trieste":"Trieste",
    "Udine":"Udine",

    // Liguria
    "Genova":"Genova",
    "Imperia":"Imperia",
    "La Spezia":"La Spezia",
    "Savona":"Savona",

    // Lombardia

    "Bergamo":"Bergamo",
    "Brescia":"Brescia",
    "Como":"Como",
    "Cremona":"Cremona",
    "Lecco":"Lecco",
    "Lodi":"Lodi",
    "Mantova":"Mantova",
    "Milano":"Milano",
    "Monza e Della Brianza":"Monza e Della Brianza",
    "Pavia":"Pavia",
    "Sondrio":"Sondrio",
    "Varese":"Varese",

    // Trentino-Alto Adige
    "Bolzano/Bozen":"Bolzano/Bozen",
    "Trento":"Trento",

    // Valle d'Aosta
    "Valle d'Aosta/Vallée d'Aoste":"Valle d'Aosta/Vallée d'Aoste",

    // Veneto
    "Belluno":"Belluno",
    "Padova":"Padova",
    "Rovigo":"Rovigo",
    "Treviso":"Treviso",
    "Venezia":"Venezia",
    "Verona":"Verona",
    "Vicenza":"Vicenza",

    // Lazio
    "Frosinone":"Frosinone",
    "Latina":"Latina",
    "Rieti":"Rieti",
    "Roma":"Roma",
    "Viterbo":"Viterbo",

    // Marche
    "Ancona":"Ancona",
    "Ascoli Piceno":"Ascoli Piceno",
    "Fermo":"Fermo",
    "Macerata":"Macerata",
    "Pesaro Urbino":"Pesaro Urbino",

    // Toscana
    "Arezzo":"Arezzo",
    "Firenze":"Firenze",
    "Grosseto":"Grosseto",
    "Livorno":"Livorno",
    "Lucca":"Lucca",
    "Massa-Carrara":"Massa Carrara",
    "Pisa":"Pisa",
    "Pistoia":"Pistoia",
    "Prato":"Prato",
    "Siena":"Siena",

    // Umbria
    "Perugia":"Perugia",
    "Terni":"Terni",

    // Abruzzo
    "Chieti":"Chieti",
    "L'Aquila":"L'Aquila",
    "Pescara":"Pescara",
    "Teramo":"Teramo",

    // Basilicata
    "Matera":"Matera",
    "Potenza":"Potenza",

    // Calabria
    "Catanzaro":"Catanzaro",
    "Cosenza":"Cosenza",
    "Crotone":"Crotone",
    "Reggio Calabria":"Reggio Calabria",
    "Vibo Valentia":"Vibo Valentia",

    // Campania
    "Avellino":"Avellino",
    "Benevento":"Benevento",
    "Caserta":"Caserta",
    "Napoli":"Napoli",
    "Salerno":"Salerno",

    // Molise
    "Campobasso":"Campobasso",
    "Isernia":"Isernia",

    // Puglia
    "Bari":"Bari",
    "Barletta Andria Trani":"Barletta Andria Trani",
    "Brindisi":"Brindisi",
    "Foggia":"Foggia",
    "Lecce":"Lecce",
    "Taranto":"Taranto",

    // Sardegna
    "Cagliari":"Cagliari",
    "Carbonia-Iglesias":"Carbonia-Iglesias",
    "Medio Campidano":"Medio Campidano",
    "Nuoro":"Nuoro",
    "Ogliastra":"Ogliastra",
    "Olbia-Tempio":"Olbia-Tempio",
    "Oristano":"Oristano",
    "Sassari":"Sassari",

    // Sicilia
    "Agrigento":"Agrigento",
    "Caltanissetta":"Caltanissetta",
    "Catania":"Catania",
    "Enna":"Enna",
    "Messina":"Messina",
    "Palermo":"Palermo",
    "Ragusa":"Ragusa",
    "Siracusa":"Siracusa",
    "Trapani":"Trapani",

    // Stranieri
    "Afghanistan": "Afghanistan",
    "Aland Islands": "Isole Aland",
    "Albania":"Albania",
    "Algeria":"Algeria",
    "American Samoa":"Samoa Americana",
    "Andorra":"Andorra",
    "Angola":"Angola",
    "Anguilla":"Anguilla",
    "Antarctica":"Antartico",
    "Antigua And Barbuda":"Antigua e Barbuda",
    "Argentina":"Argentina",
    "Armenia":"Armenia",
    "Aruba":"Aruba",
    "Australia":"Australia",
    "Austria":"Austria",
    "Azerbaijan":"Azerbaigian",
    "Bahamas":"Bahamas",
    "Bahrain":"Bahrein",
    "Bangladesh":"Bangladesh",
    "Barbados":"Barbados",
    "Belarus":"Bielorussia",
    "Belgium":"Belgio",
    "Belize":"Belize",
    "Benin":"Benin",
    "Bermuda":"Bermuda",
    "Bhutan":"Bhutan",
    "Bolivia":"Bolivia",
    "Bonaire, Sint Eustatius and Saba":"Isole BES",
    "Bosnia And Herzegovina":"Bosnia ed Erzegovina",
    "Botswana":"Botswana",
    "Bouvet Island":"Isola Bouvet",
    "Brazil":"Brasile",
    "British Indian Ocean Territory":"Territorio Britannico dell'Oceano Indiano",
    "Brunei Darussalam":"Brunei",
    "Bulgaria":"Bulgaria",
    "Burkina Faso":"Burkina Faso",
    "Burundi":"Burundi",
    "Cambodia":"Cambogia",
    "Cameroon":"Camerun",
    "Canada":"Canada",
    "Cape Verde":"Capo Verde",
    "Cayman Islands":"Isole Cayman",
    "Central African Republic":"Repubblica Centrafricana",
    "Chad":"Ciad",
    "Chile":"Cile",
    "China":"Cina",
    "Christmas Island":"Isola di Natale",
    "Cocos (keeling) Islands":"Isole Cocos",
    "Colombia":"Columbia",
    "Comoros":"Comore",
    "Congo":"Congo",
    "Congo, The Democratic Republic Of The":"Repubblica del Congo",
    "Cook Islands":"Isole di Cook",
    "Costa Rica":"Costa Rica",
    "Cote D'Ivoire":"Costa d'Avorio",
    "Croatia":"Croazia",
    "Cuba":"Cuba",
    "Curaçao":"Curaçao",
    "Cyprus":"Cipro",
    "Czech Republic":"Repubblica Ceca",
    "Denmark":"Danimarca",
    "Djibouti":"Gibuti",
    "Dominica":"Dominica",
    "Dominican Republic":"Repubblica Dominicana",
    "Ecuador":"Ecuador",
    "Egypt":"Egitto",
    "El Salvador":"El Salvador",
    "Equatorial Guinea":"Guinea Equatoriale",
    "Eritrea":"Eritrea",
    "Estonia":"Estonia",
    "Ethiopia":"Etiopia",
    "Falkland Islands (malvinas)":"Isole Falkland",
    "Faroe Islands":"Isole Faroe",
    "Fiji":"Fiji",
    "Finland":"Fillandia",
    "France":"Francia",
    "French Guiana":"Guiana Francese",
    "French Polynesia":"Polinesia Francese",
    "French Southern Territories":"Terre Australi e Antartiche Francesi",
    "Gabon":"Gabon",
    "Gambia":"Gambia",
    "Georgia":"Georgia",
    "Germany":"Germania",
    "Ghana":"Ghana",
    "Gibraltar":"Gibilterra",
    "Greece":"Grecia",
    "Greenland":"Groenlandia",
    "Grenada":"Grenada",
    "Guadeloupe":"Guadalupe",
    "Guam":"Guam",
    "Guatemala":"Guatemala",
    "Guernsey":"Guernsey",
    "Guinea":"Guinea",
    "Guinea-bissau":"Guinea-Bissau",
    "Guyana":"Guyana",
    "Haiti":"Haiti",
    "Heard Island And Mcdonald Islands":"Isole Heard e McDonald",
    "Holy See (vatican City State)":"Vaticano",
    "Honduras":"Honduras",
    "Hong Kong":"Hong Kong",
    "Hungary":"Ungheria",
    "Iceland":"Islanda",
    "India":"India",
    "Indonesia":"Indonesia",
    "Iran, Islamic Republic Of":"Iran",
    "Iraq":"Iraq",
    "Ireland":"Irlanda",
    "Isle Of Man":"Isola di Man",
    "Israel":"Israele",
    "Italy":"Italia",
    "Jamaica":"Giamaica",
    "Japan":"Giappone",
    "Jersey":"Baliato di Jersey",
    "Jordan":"Giordania",
    "Kazakhstan":"Kazakistan",
    "Kenya":"Kenya",
    "Kiribati":"Kiribati",
    "Korea, Democratic People'S Republic Of":"Corea del Nord",
    "Korea, Republic Of":"Corea del Sud",
    "Kuwait":"Kuwait",
    "Kyrgyzstan":"Kirghizistan",
    "Lao People'S Democratic Republic":"Laos",
    "Latvia":"Lettonia",
    "Lebanon":"Libano",
    "Lesotho":"Lesotho",
    "Liberia":"Liberia",
    "Libyan Arab Jamahiriya":"Libia",
    "Liechtenstein":"Liechtenstein",
    "Lithuania":"Lituania",
    "Luxembourg":"Lussemburgo",
    "Macao":"Macao",
    "Macedonia, The Former Yugoslav Republic Of":"Macedonia",
    "Madagascar":"Madagascar",
    "Malawi":"Malawi",
    "Malaysia":"Malesia",
    "Maldives":"Maldive",
    "Mali":"Mali",
    "Malta":"Malta",
    "Marshall Islands":"Isole Marshall",
    "Martinique":"Martinica",
    "Mauritania":"Mauritania",
    "Mauritius":"Mauritius",
    "Mayotte":"Mayotte",
    "Mexico":"Messico",
    "Micronesia, Federated States Of":"Stati Federati di Micronesia",
    "Moldova, Republic Of":"Moldavia",
    "Monaco":"Monaco",
    "Mongolia":"Mongolia",
    "Montserrat":"Montserrat",
    "Morocco":"Marocco",
    "Mozambique":"Mozambico",
    "Myanmar":"Birmania",
    "Namibia":"Namibia",
    "Nauru":"Nauru",
    "Nepal":"Nepal",
    "Netherlands":"Olanda",
    "Netherlands Antilles":"Antille Olandesi",
    "New Caledonia":"Nuova Caledonia",
    "New Zealand":"Nuova Zelanda",
    "Nicaragua":"Nicaragua",
    "Niger":"Niger",
    "Nigeria":"Nigeria",
    "Niue":"Niue",
    "Norfolk Island":"Isola Norfolk",
    "Northern Mariana Islands":"Isole Marianne Settentrionali",
    "Norway":"Norvegia",
    "Oman":"Oman",
    "Pakistan":"Pakistan",
    "Palau":"Palau",
    "Palestinian Territory, Occupied":"Palestina",
    "Panama":"Panama",
    "Papua New Guinea":"Papua Nuova Guinea",
    "Paraguay":"Paraguay",
    "Peru":"Peru",
    "Philippines":"Filippine",
    "Pitcairn":"Isole Pitcairn",
    "Poland":"Polonia",
    "Portugal":"Portogallo",
    "Puerto Rico":"Porto Rico",
    "Qatar":"Qatar",
    "Republic of Montenegro":"Montenegro",
    "Republic of Serbia":"Serbia",
    "Reunion":"Riunione",
    "Romania":"Romania",
    "Russian Federation":"Russia",
    "Rwanda":"Ruanda",
    "Saint Barthélemy":"Saint Barthélemy",
    "Saint Helena":"Santa Elena",
    "Saint Kitts And Nevis":"Saint Kitts And Nevis",
    "Saint Lucia":"Santa Lucia",
    "Saint Martin":"Saint Martin",
    "Saint Pierre And Miquelon":"Saint Pierre e Miquelon",
    "Saint Vincent And The Grenadines":"Saint Vincent e Grenadines",
    "Samoa":"Samoa",
    "San Marino":"San Marino",
    "Sao Tome And Principe":"São Tomé e Príncipe",
    "Saudi Arabia":"Arabia Saudita",
    "Senegal":"Senegal",
    "Serbia And Montenegro":"Serbia e Montenegro",
    "Seychelles":"Seychelles",
    "Sierra Leone":"Sierra Leone",
    "Singapore":"Singapore",
    "Sint Maarten":"Sint Maarten",
    "Slovakia":"Slovacchia",
    "Slovenia":"Slovenia",
    "Solomon Islands":"Isole Solomon",
    "Somalia":"Somalia",
    "South Africa":"Sud Africa",
    "South Georgia And The South Sandwich Islands":"Georgia del Sud e Isole Sandwich Meridionali",
    "South Sudan":"Sudan Meridionale",
    "Spain":"Spagna",
    "Sri Lanka":"Sri Lanka",
    "Sudan":"Sudan",
    "Suriname":"Suriname",
    "Svalbard And Jan Mayen":"Svalbard e Jan Mayen",
    "Swaziland":"Swaziland",
    "Sweden":"Svezia",
    "Switzerland":"Svizzera",
    "Syrian Arab Republic":"Siria",
    "Taiwan, Province Of China":"Taiwan",
    "Tajikistan":"Tagikistan",
    "Tanzania, United Republic Of":"Tanzania",
    "Thailand":"Thailandia",
    "Timor-leste":"Timor Est",
    "Togo":"Togo",
    "Tokelau":"Tokelau",
    "Tonga":"Tonga",
    "Trinidad And Tobago":"Trinidad e Tobago",
    "Tunisia":"Tunisia",
    "Turkey":"Turchia",
    "Turkmenistan":"Turkmenistan",
    "Turks And Caicos Islands":"Turks e Caicos",
    "Tuvalu":"Tuvalu",
    "Uganda":"Uganda",
    "Ukraine":"Ucraina",
    "United Arab Emirates":"Emirati Arabi",
    "United Kingdom":"Regno Unito",
    "United States":"Stati Uniti",
    "United States Minor Outlying Islands":"Isole Minori degli Stati Uniti",
    "Uruguay":"Uruguay",
    "Uzbekistan":"Uzbekistan",
    "Vanuatu":"Vanuatu",
    "Venezuela":"Venezuela",
    "Viet Nam":"Vietnam",
    "Virgin Islands, British":"Isole Vergini Britanniche",
    "Virgin Islands, U.s.":"Isole Vergini Americane",
    "Wallis And Futuna":"Wallis e Futuna",
    "Western Sahara":"Sahara Occidentale",
    "Yemen":"Yemen",
    "Zambia":"Zambia",
    "Zimbabwe":"Zimbabwe",


    //Zone
    "zone.all": "-- Tutte le Zone --",
    "zone.italy":"Italiani",
    "zone.foreign":"Stranieri",
    "zone.strangers":"Stranieri",
    "zone.europe-west":"Europa Occidentale",
    "zone.europe-east":"Europa Orientale",
    "zone.europe-north":"Europa Settentrionale",
    "zone.europe-south":"Europa Meridionale",
    "zone.america":"Americhe",
    "zone.asia":"Asia",
    "zone.africa":"Africa",
    "zone.australia":"Australia",
    "zone.oceania":"Oceania",
    "zone.world":"Altro",

    //Tipology
    "tipology.all":"- Tutti i Registranti -",
    "tipology.naturalPerson":"Persone Fisiche",
    "tipology.companies":"Società/Ditte",
    "tipology.freelance":"Liberi Professionisti/Ordini Professionali",
    "tipology.noprofitCo":"Enti no-profit",
    "tipology.publicCo":"Enti pubblici",
    "tipology.other":"Altri soggetti",


    // Azioni Pannello

    "panel.action.print":"Stampa Grafico",
    "panel.action.export":"Esporta",
    "panel.action.export.png":"Esporta Grafico nel Formato PNG",
    "panel.action.export.svg":"Esporta Grafico nel Formato SVG",
    "panel.action.chartsToTable":"Visualizza Dati Grafico",
    "panel.action.export.csv": "Esporta Dati nel Formato CSV",

    // Titoli Pannello
//  "drillDown.yearly": "tutti gli anni",
//  "drillDown.montly": "per mese per l'anno ",
//  "drillDown.daily": "per giorno per mese di ",
//  "drillDown.hourly": "per ora per il giorno ",



    // Messages

    //"domain.description.growth":"<p>Con questo grafico si vuole rappresentare la crescita dei nomi a dominio. Sono presenti due serie:</p><ul><li><em>Numero Domini Registrati</em>, disegnata con grafico ad area di colore blu (asse Y di sinitra), rappresenta il numero di nomi a dominio raggiunto ogni mese con indicazione delle percentuali di crescita rispetto sia al mese precedente che all'inizio dell'anno.</li><li>'Tasso di Crescita annuale', disegnata con grafico a linea di colore rosso (asse Y di destra), rappresenta il tasso di crescita dei nomi a dominio su base annuale.</li></ul>Nel grafico sono presenti inoltre dei marcatori di colore verde per ogni anno, che rappresentano il numero di nomi a dominio raggiunto al termine dell'anno indicato. E' possibile effettuare un ingrandimento dell'asse X per visualizzare con maggior precisione un periodo temporale di interesse.",

    "domain.growth.description":"<p>Il grafico mostra la crescita dei nomi a dominio .it. Sono presenti due serie:</p><ul><li><strong>Domini Registrati</strong>, rappresentata con un grafico ad area di colore blu (asse y di sinistra), indica il totale dei nomi a dominio presenti nel database del Registro ad ogni fine mese. Sono riportate anche le percentuali di crescita rispetto al mese precedente e all’inizio dell’anno.</li><li><strong>Tasso di Crescita</strong>, rappresentata con un grafico a linea di colore rosso (asse y di destra), indica la crescita dei nomi a dominio su base annuale.</li></ul>",

    "domain.names.growth":"Grafico della crescita dei nomi a dominio",
    "domain.growth.title":"Grafico della crescita dei nomi a dominio",
    "domain.growth.xLabel": "XLABEL",
    "domain.growth.yLabel": "YLABEL",

    "domain.registration.title":"Grafico Domini Registrati",
    "domain.registration.yLabel":"Domini Registrati",
    "domain.registration.description":"Il grafico mostra il numero dei nomi a dominio registrati su base annuale, mensile, giornaliera e oraria. È possibile effettuare il drilldown cliccando sulle singole colonne.",

    "domain.transfer.title": "Grafico Trasferimenti Domini",
    "domain.transfer.description":"Il grafico mostra il numero dei nomi a dominio trasferiti da un Registrar ad un altro. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese e giorno.",
    "domain.transfer.yLabel":"Domini Trasferiti",

    "domain.transferWithTrade.title":"Grafico Domini Trasferiti con Modifica del Registrante",
    "domain.transferWithTrade.description":"Il grafico mostra il numero dei nomi a dominio trasferiti da un Registrar ad un altro con contestuale modifica del Registrante. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese e giorno.",
    "domain.transferWithTrade.yLabel": "Domini Trasferiti e Mod. Registrante",

    "domain.transferBulk.title": "Grafico Domini Trasferiti Tramite Bulk",
    "domain.transferBulk.description":"Il grafico mostra il numero dei nomi a dominio trasferiti da un Registrar ad un altro tramite una operazione di bulk-transfer. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese e giorno.",
    "domain.transferBulk.yLabel":"Domini Trasferiti Tramite Bulk",

    "domain.transferTotal.title":"Grafico Totale Trasferimenti Domini",
    "domain.transferTotal.description":"Il grafico mostra il numero totale dei nomi a dominio trasferiti da un Registrar ad un altro. Include le operazioni di trasferimento, di trasferimento con modifica del Registrante e le operazioni bulk. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese e giorno.",
    "domain.transferTotal.yLabel":"Domini Trasferiti (Tutti)",

    "domain.restore.title":"Grafico Domini Recuperati",
    "domain.restore.description":"Il grafico mostra il numero dei nomi a dominio per i quali è stata effettuata un’operazione di recupero a seguito di una cancellazione. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese e giorno.",
    "domain.restore.yLabel":"Domini Recuperati",

    "domain.delete.title":"Grafico Domini Cancellati",
    "domain.delete.description": "Il grafico mostra il numero dei nomi a dominio cancellati su base annuale, mensile, giornaliera e oraria. È possibile effettuare il drilldown cliccando sulle singole colonne.",
    "domain.delete.yLabel": "Domini Cancellati",

    "domain.reassign.title":"Grafico Domini Riassegnati",
    "domain.reassign.description":"Il grafico mostra il numero dei nomi a dominio, sottoposti a procedura di opposizione, per i quali è stata effettuata un’operazione di riassegnazione. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese.",
    "domain.reassign.yLabel":"Domini Riassegnati",

    "domain.renewal.title":"Grafico Domini Rinnovati",
    "domain.renewal.description":"Il grafico mostra il numero dei nomi a dominio rinnovati annualmente. Cliccando sulle singole colonne è possibile effettuare il drilldown e ottenere il dettaglio a livello di mese e giorno.",
    "domain.renewal.yLabel": "Domini Rinnovati",

    "select.allYears":"-- Tutti Gli Anni --",

    "allYears":"Tutti Gli Anni",
    "yearly":"annuale",
    "monthly": "mensile",
    "daily":"giornaliero",
    "hourly":"orario",
    "delete": "Cancellazioni",
    "transferTrade":"Cambio Registrar e Registrante",
    "transfer":"Trasferimenti",
    "transfer_in":"Trasferimenti in Ingresso",
    "transfer_out":"Trasferimenti in Uscita",
    "transferTotal":"Trasferimenti Totali",
    "registrazioni":"Registrazioni",
    "renewal":"Rinnovi",
    "restore":"Recuperi",

}



// WEBPACK FOOTER //
// ./src/i18n/it.js